import React from 'react';

const NearbyRVRentalContent = props => {
  const { locations, rvType } = props;

  return (
    <React.Fragment>
      {locations.map(location => {
        let { title, listing_count, url } = location;

        title = `${rvType} Rental ${title}`;
        return (
          <a
            href={url}
            title={title}
            key={title}
            className="flex justify-start w-full pr-6 mb-1 text-sm text-gray-900 whitespace-wrap md:w-1/3 sm:w-1/2 xs:w-1/2 md:text-base group">
            <span className="no-underline group-hover:underline">{title}</span>
            {listing_count && (
              <span className="ml-2 text-sm font-normal text-gray-500">({listing_count})</span>
            )}
          </a>
        );
      })}
    </React.Fragment>
  );
};

export default NearbyRVRentalContent;
